import { axios } from '../../../lib'

export const ordersReport = (data: any): Promise<any> => {
  return axios.get('/reports/orders', {
    params: {
      ...data
    }
  })
}

export const generateProposalReportById = async (id: string): Promise<any> => {
  try {
    const response: any = await axios.get(`/orders/${id}/pdf`)
    return response
  } catch (error) {
    return error
  }
}

export const generateOrderReportById = async (id: string): Promise<any> => {
  try {
    const response: any = await axios.get(`/orders/${id}/pdf`)
    return response
  } catch (error) {
    return error
  }
}

export const debtsReport = (data: any): Promise<any> => {
  return axios.get('/reports/debts', {
    params: {
      ...data
    }
  })
}

export const commissionsReport = (data: any): Promise<any> => {
  return axios.get('/reports/commissions', {
    params: {
      ...data
    }
  })
}

export const abcProductsReport = (data: any): Promise<any> => {
  return axios.get('/reports/products-abc', {
    params: {
      ...data
    }
  })
}

export const abcClientsReport = (data: any): Promise<any> => {
  return axios.get('/reports/customers-abc', {
    params: {
      ...data
    }
  })
}
